import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import styled from 'styled-components';

import { toDate, toRgba } from 'shared/utilities';
import { CalendarItemModel } from 'shared/models';
import { UiIcon } from 'shared/uikit-new';
import { CalendarItemTypeEnum } from 'shared/enums';
import { useObservable } from 'shared/hooks';

import { CalendarPageCalendarItemPreview } from 'pages/calendar/components/CalendarPageCalendarItemPreview';
import { Store } from 'pages/calendar/store';

import './styles.scss';

type PropsType = {
    calendarItem: CalendarItemModel;
};

const View = styled.div<{ $hoverBackgroundColor: string }>`
    &:hover {
        background-color: ${props => props.$hoverBackgroundColor};
    }
`;
export const CalendarPageMonthCalendarItem = observer(function CalendarPageMonthCalendarItem({ calendarItem }: PropsType) {
    const store = useObservable({
        now: toDate(),
        isOpened: false,
        bounds: null as null | DOMRect,
    });

    return (
        <>
            <View
                onClick={e => {
                    if(calendarItem.type.is(CalendarItemTypeEnum.Task) && calendarItem.taskTrackerTask?.id) {
                        Store.set('taskTrackerTask', { id: calendarItem.taskTrackerTask.id });
                        return;
                    }
                    store.update({
                        bounds: e.currentTarget.getBoundingClientRect(),
                        isOpened: !store.isOpened,
                    });
                }}
                $hoverBackgroundColor={toRgba(calendarItem.color, 0.15)}
                className={classnames('calendar-page-month-calendar-item', `calendar-page-month-calendar-item--${calendarItem.typeId}`, {
                    'calendar-page-month-calendar-item--past': toDate(calendarItem.startAt).isBefore(store.now, 'day'),
                    'calendar-page-month-calendar-item--all-day': calendarItem.isAllDayEvent,
                    [`calendar-page-month-calendar-item--task-tracker-task-${calendarItem.taskTrackerTask?.statusId}`]: !!calendarItem.taskTrackerTask?.id,
                })}
            >
                {calendarItem.type.is(CalendarItemTypeEnum.Task) && <UiIcon.CircleCheckBig size={12} />}
                {!calendarItem.type.is(CalendarItemTypeEnum.Task) && (
                    <div
                        className='calendar-page-month-calendar-item__badge'
                        style={{
                            backgroundColor: calendarItem.color,
                        }}
                    />
                )}
                {!calendarItem.isAllDayEvent && <div className='calendar-page-month-calendar-item__time'>{toDate(calendarItem.startAt).format('HH:mm')}</div>}
                <div className='calendar-page-month-calendar-item__subject'>{calendarItem.subject}</div>
            </View>
            <CalendarPageCalendarItemPreview calendarItem={calendarItem} isOpened={store.isOpened} onClose={() => store.set('isOpened', false)}  bounds={store.bounds}/>
        </>
    );
});
